/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleCreateLineItemFromPercentage extends models.BillingRuleCreateLineItemBase {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleCreateLineItemFromPercentage");
    }

    getFixupPrototypeFunction() { return BillingRuleCreateLineItemFromPercentage.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleCreateLineItemFromPercentage>): BillingRuleCreateLineItemFromPercentage {
        let obj = Object.assign(new BillingRuleCreateLineItemFromPercentage(), model);
        BillingRuleCreateLineItemFromPercentage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleCreateLineItemFromPercentage>): BillingRuleCreateLineItemFromPercentage {
        if (!model) return null;
        return BillingRuleCreateLineItemFromPercentage.newInstance(<BillingRuleCreateLineItemFromPercentage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleCreateLineItemFromPercentage) {
        if (!obj) return;

        models.BillingRuleCreateLineItemFromPercentage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleCreateLineItemFromPercentage): boolean {
        if (models.BillingRuleCreateLineItemBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleCreateLineItemFromPercentage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.percentage === undefined) {
            this.percentage = 0;
        }
    }

    /**
     * Percentage of the billing rule
     */
    percentage: number;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

}
